// Dependencies
import React from 'react';
import classNames from 'classnames';

const Gradient = ({ themes, currentTheme }) => (
  <div>
    <div
      className={classNames('gradient gradient--default', {
        'gradient--hidden': currentTheme !== 'default',
        'gradient--active': currentTheme === 'default'
      })}
    />
    {[...Array(themes).keys()].map(({ background }, i) =>
      <div
        className={classNames(`gradient gradient--${i + 1}`, {
          'gradient--hidden': currentTheme !== i + 1,
          'gradient--active': currentTheme === i + 1
        }
)}
        key={i}
      />)}
  </div>
);

export default Gradient;



/** WEBPACK FOOTER **
 ** ./src/js/components/gradient.js
 **/